import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Grid, Icon, LinkText, LinkCTA, List, Typography, } from "../ecosystem";
import { PageHeading, EmailForm } from "../ecosystem/mybswh";
import * as types from "../../constants/actionTypes";
import articleImg from "../../images/ArticleImg.png"
import Spinner from '../common/spinner';

const ScrubbingInLanding = (props) => {

    const [email, setEmail] = useState("");
    const [optInError, setOptInError] = useState(false);

    const { scrubbingInOptInRsp, scrubbingInEmailOptIn } = props;

    const { waiting = false, success = false, error = false } = scrubbingInOptInRsp;

    useEffect(() => {
        if (optInError !== error) {
            setOptInError(error);
        }
    }, [error]);

    const onEmailChange = (e) => {
        const { value } = e.target;
        setEmail(value);
    }

    const onSubmitEmail = () => {
        logUI("MBHWeb.UI.ScrubbingInLanding.Email.OnSubmit", new Date(), Tools.getURLPath(), { email });
        scrubbingInEmailOptIn(email);
    }

    const resetOptInError = () => {
        if (optInError) {
            setOptInError(false);
        }
    }

    const blogLogo = 'https://bswcdndesign-prod.bswhealth.com/content/logo/scrubbing-in.svg';

    return (
        <Grid className="body-content scrubbing-in-container">
            {waiting && <Spinner />}
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading
                        className="scrubbingIn-header"
                        heading={<><span className="scrubbingIn-header__text">Health tips & advice with</span> <img src={blogLogo} alt="Scrubbing In" /></>}
                        description="Hands-on health care discussions"
                    />
                    <div className="row">
                        <div className="col-12 col-lg-7">
                            <Typography type="body-03" color="$color-primary-a2" tag="p">Everyone wants to be healthy and live well, but where to start?
                                Today's world of information overload can seem overwhelming. Which sources should you trust? What news is really relevant?
                                And how does any of it apply to you?</Typography>

                            <Typography type="body-03" color="$color-primary-a2" tag="p">
                                Scrubbing In® is different. We are the voice you can trust to break through the noise.
                                Because every word is written with you in mind.
                            </Typography>

                            <div className="article-container">
                                <Typography type="heading-05">Featured Article</Typography>

                                <div className="blog">
                                    <img src={articleImg} width="100%" alt="article-image" />
                                    <div className="cta-title">
                                        <LinkText target="_blank" href="https://scrubbing.in/how-exercise-impacts-your-blood-pressure/" typographyType="body-03" >
                                            How exercise can improve your blood pressure <Icon name="arrow" />
                                        </LinkText>
                                    </div>
                                    <Typography type="body-01" tag="p">November 8th, 2021 - By Michaela Jones, BSEd, CSCS, Pn1</Typography>
                                    <Typography type="body-02" tag="p">If you have it, this article concerns your least favorite subject. The ever-looming elephant in many of our rooms—high blood pressure. The medical condition known as high blood pressure...</Typography>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-4 offset-lg-1">
                            <div className="sign-up-container">
                                <Typography type="body-02">Sign up to receive inspiring health tips and advice from Baylor Scott & White.</Typography>
                                {success 
                                    ? <div className="sign-up-container__msg">
                                        <Typography type="heading-02" bold color="$color-primary-a3" tag="div">Thank you!</Typography>
                                        <Typography type="body-02" color="$color-primary-a3">Your email has been successfully submitted.</Typography>
                                    </div>
                                    : <EmailForm
                                        value={email}
                                        name="emailForm"
                                        id="emailForm"
                                        label="Enter your email"
                                        onChange={e => onEmailChange(e)}
                                        onFocus={() => { resetOptInError(); }}
                                        required
                                        errorMsg="Enter a valid email address"
                                        onSubmit={() => { onSubmitEmail(); }}
                                        hintMsg={optInError ?
                                            <>
                                                <div className="bsw-text-field__validation-icon">
                                                    <Icon
                                                        name="exclamation"
                                                        color="$color-system-b1"
                                                        size="small"
                                                    />
                                                </div>
                                                <Typography type="meta-01" color="$color-system-b1">
                                                    Something went wrong. Try again later.
                                                </Typography>
                                            </>
                                            : ""
                                        }
                                    />
                                }
                            </div>
                            <div className="topic-list-title">
                                <Typography type="heading-05" tag="p">Sample Topics</Typography>
                                <List
                                    typographyType="body-02"
                                    list={[
                                        "Allergies & ENT",
                                        "Cancer",
                                        "Children's Health",
                                        "Cold & Flu",
                                        "Diabetes",
                                        "Women's Health"
                                    ]}
                                ></List>
                                <div className="cta-title">
                                    <LinkCTA
                                        href="https://scrubbing.in/"
                                        target="_blank"
                                        typographyType="body-02"
                                        icon="arrow-45"
                                        onClick={() => {
                                            logUI(
                                                "MBHWeb.UI.ScrubbingInLanding.TakeMe.Clicked",
                                                new Date(),
                                                Tools.getURLPath()
                                            );
                                        }}>Take me to Scrubbing In</LinkCTA>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Grid>
    )
}


const mapStateToProps = (state) => {
    return {
        scrubbingInOptInRsp: state.marketingEmailOptIn.scrubbingIn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        scrubbingInEmailOptIn: (emailId) => {
            dispatch({ type: types.SET_SCRUBBING_IN_EMAIL_OPT_IN, data: { email: emailId } });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScrubbingInLanding));